import {environment} from '../environment'
import axios from 'axios';
import { useBasicAuth } from '../../shared/components/auth/withBasicAuth';

const urlAPI = environment.getApi('orgaos');

export const check = () => useBasicAuth.checkToken();

export const findOrgaoById = (id) => 
  axios.get(urlAPI + "/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllOrgao = () => 
  axios.get(urlAPI + "/findAll", environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllOrgaoByUser = (user) => 
  axios.get(urlAPI + "/byUser/" + user.id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllOrgaoByUserADM = (user) => 
  axios.get(urlAPI + "/byUserADM/" + user.id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });
  
export const findAllOrgaoByDeleted = (value) => 
  axios.get(urlAPI + "/deleted/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  }); 

export const findAllOrgaoByEnabled = (value) => 
  axios.get(urlAPI + "/enabled/" + value , environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const addOrgao = (obj) => 
  axios.post(urlAPI + "/addOrgao" , JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const updateOrgao = (obj) => 
  axios.put(urlAPI + "/updateOrgao/" + obj.orgao.id, JSON.stringify(obj), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const deleteOrgao = (id) => 
  axios.delete(urlAPI + "/deleteOrgao/" + id, environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });



export const findAllByOrgaoUser_orgao = (orgao) => 
  axios.post(urlAPI + "/orgaoUser/orgao", JSON.stringify(orgao), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });

export const findAllByOrgaoUser_user = (user) => 
  axios.post(urlAPI + "/orgaoUser/user", JSON.stringify(user), environment.HEADER)
  .then(({data}) => data)
  .catch(e => {
    useBasicAuth.handleError(e);
  });